<template>
    <v-container
        fluid
        class="mb-5"
        data-v-sticky-container
    >
        <v-row v-if="objProyecto.banAccion == true">
            <v-col
                cols="12"
                md="6"
            >
                <v-btn
                    v-if="!concluirObservaciones && !expandObs"
                    depressed
                    color="blue"
                    rounded
                    :dark="!infoInv"
                    :disabled="infoInv"
                    @click="openInfoInv"
                >
                    <v-icon left>
                        mdi-account-outline
                    </v-icon>
                    Datos Investigador
                </v-btn>
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="text-right"
            >
                <v-btn
                    v-if="mostrarAccionesAprobaciones"
                    class="ml-1"
                    depressed
                    color="success"
                    rounded
                    @click="dialogAprobar = true"
                >
                    <v-icon left>
                        mdi-check-outline
                    </v-icon>
                    Aprobar
                </v-btn>
                <!-- <v-btn
                    v-if="mostrarAccionesAprobaciones"
                    class="ml-1"
                    depressed
                    color="error"
                    rounded
                    @click="dialogNoAprobar = true"
                >
                    <v-icon left>
                        mdi-close-outline
                    </v-icon>
                    No aprobar
                </v-btn> -->

                <v-badge
                    v-if="objConvocatoriaActiva.revision && objProyecto.obsComitePorVerificar > 0"
                    color="error"
                    :content="objProyecto.obsComitePorVerificar"
                    :value="objProyecto.obsComitePorVerificar"
                    overlap
                >
                    <v-btn
                        depressed
                        class="ml-1"
                        color="blue"
                        rounded
                        :dark="!observacionesVal"
                        :disabled="observacionesVal"
                        @click="openObservacionesVal"
                    >
                        <v-icon left>
                            mdi-check-circle-outline
                        </v-icon>
                        verificar contestaciones
                    </v-btn>
                </v-badge>

                <v-btn
                    v-else
                    depressed
                    class="ml-1"
                    color="blue"
                    rounded
                    :dark="!observaciones"
                    :disabled="observaciones"
                    @click="openObservaciones"
                >
                    <v-icon left>
                        mdi-forum
                    </v-icon>
                    Observaciones
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                v-show="infoInv && !concluirObservaciones && !expandObs"
                cols="12"
                md="3"
                transition="slide-x-transition"
            >
                <card-usuario-datos-generales
                    v-sticky="optionsSticky"
                    class="ma-0"
                    :nue="objProp.idEmpleado"
                    :obj-prop="objProp.participantes.investigadorPrincipal"
                    :prop-loading="loading"
                />
            </v-col>
            <v-col
                v-if="!concluirObservaciones && !expandObs"
                cols="12"
                :md="observaciones || observacionesVal ? 8 : 9"
            >
                <v-alert
                    v-if="objProyecto.banAccion == true && objProyecto.lstDictamenes.length > 0"
                    class="mx-3"
                    outlined
                    dismissible
                    color="#0e345b"
                    border="top"
                    colored-border
                    elevation="2"
                    style="border-color: #0e345b!important;"
                >
                    <div
                        class="text-h6"
                        style="color: #0e345b!important;"
                    >
                        Dictámenes del proyecto
                    </div>
                    <div 
                        v-for="(n, index) in objProyecto.lstDictamenes"
                        :key="'item_dictamen_' + index"
                        style="color: #0e345b!important;"
                    >
                        <i>{{ n.folioDictamen }}</i> - <b>{{ n.idEstatusFkNavigation.descripcion }}</b> ({{ n.idConvocatoriaFkNavigation.descripcion }})
                    </div>
                </v-alert>
                <v-alert
                    v-if="objProyecto.banAccion == true && (objProyecto.idEstatusComite == 3 || objProyecto.idEstatusComite == 4 || objProyecto.idEstatusComite == 5 || objProyecto.idEstatusComite == 6 || objProyecto.idEstatusComite == 9)"
                    class="mx-3 pt-5"
                    border="top"
                    colored-border
                    :type="objProyecto.idEstatusComite == 3 ? 'error' : objProyecto.idEstatusComite == 4 ? 'success' : objProyecto.idEstatusComite == 4 || objProyecto.idEstatusComite == 5 || objProyecto.idEstatusComite == 9 ? 'info' : 'warning'"
                    elevation="2"
                >
                    El estatus actual del Protocolo del Proyecto es: <b><i>{{ objProyecto.estatusComite }}</i></b>
                    <!-- 
                    <div
                        v-if="objProyecto.idEstatusComite == 3"
                        class="pt-1"
                    >
                        <b>Justificación: </b> {{ objProyecto.observacionesComite }}
                    </div> -->
                </v-alert>
                <form-datos-proyecto
                    key="fdp-1"
                    :id-proyecto="idProyecto"
                    :obj="objProyecto.datosProyecto"
                    :id-accion="3"
                />
                <form-generales-proyecto
                    key="fg-1"
                    :id-proyecto="idProyecto"
                    :obj="objProyecto.generalesProyecto"
                    :id-accion="3"
                />
                <form-participantes
                    key="fp-1"
                    :id-proyecto="idProyecto"
                    :obj="objProyecto.participantes"
                    :id-accion="3"
                />
                <form-anexos
                    key="fa-1"
                    :id-proyecto="idProyecto"
                    :obj="objProyecto.anexos"
                    :id-accion="3"
                />
            </v-col>
            <v-col
                v-show="observaciones || observacionesVal"
                :md="concluirObservaciones || expandObs ? '12': '4'"
                transition="slide-x-reverse-transition"
            >
                <card-observaciones-s-t
                    v-show="observaciones"
                    key="cardObservaciones"
                    v-sticky="optionsSticky"
                    class="ma-0"
                    :id-proyecto="idProyecto"
                    :id-estatus="objProyecto.idEstatus"
                    :id-estatus-comite="objProyecto.idEstatusComite"
                    :id-convocatoria-proyecto="objProyecto.idConvocatoria"
                    :expand-obs="expandObs"
                    :nue-registra="objProyecto.idEmpleado"
                    :fn-set-concluir-observaciones="setConcluirObservaciones"
                    :fn-set-expand="setExpandObs"
                    :fn-on-save-obs-principal="setIdEstatusComite"
                    :ban-update-obs="banUpdateObs"
                />
                <card-observaciones-s-t
                    v-show="observacionesVal"
                    key="cardObservacionesEvaluacion"
                    v-sticky="optionsSticky"
                    class="ma-0"
                    :id-proyecto="idProyecto"
                    :id-estatus="objProyecto.idEstatus"
                    :id-estatus-comite="objProyecto.idEstatusComite"
                    :id-convocatoria-proyecto="objProyecto.idConvocatoria"
                    :expand-obs="expandObs"
                    :nue-registra="objProyecto.idEmpleado"
                    :fn-set-concluir-observaciones="setConcluirObservaciones"
                    :fn-set-expand="setExpandObs"
                    :fn-on-save-obs-principal="setIdEstatusComite"
                    :fn-actualizar-obs-por-verificar="actualizarObsPorVerificar"
                    :validacion="true"
                    :ban-update-obs="banUpdateObs"
                />
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialogAprobar"
            persistent
            max-width="290"
        >
            <v-card>
                <v-card-title
                    class="text-h6"
                    style="background-color: #0e345b; color: white;"
                >
                    <v-icon
                        left
                        color="white"
                    >
                        mdi-check-outline
                    </v-icon>
                    Aprobar
                </v-card-title>
                <v-card-text class="pt-4">
                    ¿Está seguro de querer dar como aprobado el Protocolo del Proyecto? Si lo hace, ya no podrá revertir estos cambios.
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        depressed
                        rounded
                        :loading="loadingAction"
                        @click="dialogAprobar = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="#0e345b"
                        rounded
                        depressed
                        dark
                        :loading="loadingAction"
                        @click="guardarProtocoloProyectoAprobado"
                    >
                        Aprobar
                    </v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogNoAprobar"
            persistent
            max-width="350"
        >
            <v-card>
                <v-card-title
                    class="text-h6"
                    style="background-color: #0e345b; color: white;"
                >
                    <v-icon
                        left
                        color="white"
                    >
                        mdi-close-outline
                    </v-icon>
                    No Aprobar
                </v-card-title>
                <v-card-text class="pt-4">
                    ¿Está seguro de querer dar como <b>"No Aprobado"</b> el Protocolo del Proyecto? Si lo hace, ya no podrá revertir estos cambios.
                    <br>&nbsp;
                    <v-textarea
                        v-model="observacionesComite"
                        label="Justificación de No Aprobación *"
                        placeholder="Escribe la justificación para asignar la No Aprobación del Protocolo del Proyecto"
                        auto-grow
                        rows="1"
                        :rules="[(v) => !!v || 'Campo obligatorio']"
                        required
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        depressed
                        rounded
                        :loading="loadingAction"
                        @click="dialogNoAprobar = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="#0e345b"
                        rounded
                        depressed
                        :dark="!(observacionesComite == null || observacionesComite == '')"
                        :disabled="observacionesComite == null || observacionesComite == ''"
                        :loading="loadingAction"
                        @click="guardarProtocoloProyectoNoAprobado"
                    >
                        No Aprobar
                    </v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    

        <v-snackbar
            key="snackbarFormProtocoloProyecto"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { putProtocoloProyectoAprobado, putProtocoloProyectoNoAprobado } from "@/api";
import VueStickyDirective from '@renatodeleao/vue-sticky-directive'

export default {
  name: "FormProtocoloProyectoEvaluacion",
  components: {
    CardUsuarioDatosGenerales: () => import("../compartidos/CardUsuarioDatosGenerales"),
    CardObservacionesST: () => import("../compartidos/CardObservacionesST"),
    FormDatosProyecto: () => import("../formularioProtocoloProyecto/formDatosProyecto/FormDatosProyecto"),
    FormGeneralesProyecto: () => import("../formularioProtocoloProyecto/formGeneralesProyecto/FormGeneralesProyecto"),
    FormParticipantes: () => import("../formularioProtocoloProyecto/formParticipantes/FormParticipantes"),
    FormAnexos: () => import("../formularioProtocoloProyecto/formAnexos/FormAnexos"),
  },
  props: {
    idProyecto: {
      type: Number,
      required: true,
    },
    objProp: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      snackbar: false,
      snackbarColor: "",
      snackbarTexto: "",
      optionsSticky: {
        topSpacing: 80,
        resizeSensor: true,
      },
      infoInv: true,
      observaciones: false,
      observacionesVal: false,
      objProyecto: { idEstatusComite: 0, obsComitePorVerificar: 0, lstDictamenes: [] },
      permisoObsPrinc: false,

      dialogAprobar: false,
      dialogNoAprobar: false,
      observacionesComite: '',
      loadingAction: false,

      concluirObservaciones: false,

      banUpdateObs: 0,
      expandObs: false,

    };
  },
  computed: {
      ...mapGetters("oidc", ["oidcUser"]),
      ...mapState(["objConvocatoriaActiva", "respuestaConvocatoriaActiva"]),
      mostrarAccionesAprobaciones () {
          return (this.objProyecto.idEstatusComite == 2 /* || this.objProyecto.idEstatusComite == 5 || this.objProyecto.idEstatusComite == 6  || this.objProyecto.idEstatusComite == 9 */) && this.objProyecto.datosProyecto.idConvocatoria == this.objConvocatoriaActiva.idConvocatoria && this.objConvocatoriaActiva.revision == true && this.permisoObsPrinc == true
      }
   },
  watch: {
  },
  async created () {
    await Object.assign(this.objProyecto, this.objProp);

    if(await this.tienePermisoServicio({ permiso: 'Evaluación: Observaciones Principales' }) == true) {
        this.permisoObsPrinc = true;
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions(['tienePermisoServicio']),
    openInfoInv () {
      this.infoInv = true;
      this.observaciones = false;
      this.observacionesVal = false;
    },
    openObservaciones () {
      this.observaciones = true;
      this.observacionesVal = false;
      this.infoInv = false;
    },
    openObservacionesVal () {
      this.observacionesVal = true;
      this.infoInv = false;
    },
    setIdEstatusComite (idEstatus) {
        this.$set(this.objProyecto, 'idEstatusComite', idEstatus)
    },
    setConcluirObservaciones (value) {
        this.concluirObservaciones = value;
    },
    async guardarProtocoloProyectoAprobado () {
      var self = this;
      this.loadingAction = true;
      
      self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = "";

      try {

        let response = await putProtocoloProyectoAprobado(self.idProyecto);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Guardado correcto") {
              self.loadingAction = false;
              self.dialogAprobar = false;

              self.objProyecto.idEstatusComite = 4;

              self.openInfoInv();

              self.snackbarTexto = "Protocolo del Proyecto Aprobado con éxito.";
              self.snackbarColor = "success";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto =
              "FormProtocoloProyectoEvaluacion: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingAction = false;
          }
        } else {
          self.snackbarTexto = "FormProtocoloProyectoEvaluacion: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingAction = false;
        }
      } catch (e) {
        self.loadingAction = false;
        self.snackbarTexto = "FormProtocoloProyectoEvaluacion: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    async guardarProtocoloProyectoNoAprobado () {
      var self = this;
      this.loadingAction = true;
      
      self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = "";

      try {

        let response = await putProtocoloProyectoNoAprobado(self.idProyecto, self.observacionesComite);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Guardado correcto") {
              self.loadingAction = false;
              self.dialogNoAprobar = false;

              self.objProyecto.idEstatusComite = 3;
              self.objProyecto.observacionesComite = self.observacionesComite;

              self.openInfoInv();

              self.snackbarTexto = "Protocolo del Proyecto No Aprobado con éxito.";
              self.snackbarColor = "success";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto =
              "FormProtocoloProyectoEvaluacion: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loadingAction = false;
          }
        } else {
          self.snackbarTexto = "FormProtocoloProyectoEvaluacion: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loadingAction = false;
        }
      } catch (e) {
        self.loadingAction = false;
        self.snackbarTexto = "FormProtocoloProyectoEvaluacion: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
    actualizarObsPorVerificar () {
        this.objProyecto.obsComitePorVerificar = this.objProyecto.obsComitePorVerificar-1;
        if(this.objProyecto.obsComitePorVerificar == 0) {
            this.openObservaciones();
            this.banUpdateObs++;
        }
    },
    setExpandObs (val) {
        this.expandObs = val;
    }
  }
};
</script>
